import Vue from 'vue'
import VueRouter from 'vue-router'

import CampaignEdit from '../pages/Campaigns/CampaignEdit'
import CampaignShow from '../pages/Campaigns/CampaignShow'
import AutoCampaignEdit from '../pages/AutoCampaigns/AutoCampaignEdit'
import AutoCampaignShow from '../pages/AutoCampaigns/AutoCampaignShow'
import LoyaltyPoints from '../pages/LoyaltyPoints'
import ImpactReport from '../pages/Reports/ImpactReport'
import SharingLinks from '../pages/MerchantSettings/SharingLinks'
import UsersIndex from '../pages/Users/UsersIndex'
import UsersEdit from '../pages/Users/UsersEdit'
import Program from '../pages/MerchantSettings/Program'
import Passcode from '../pages/Passcode/Passcode'
import Stashboard from '../pages/Stashboard/Stashboard'

Vue.use(VueRouter)

const router =  new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/campaigns/:id/edit',
      name: 'CampaignEdit',
      component: CampaignEdit,
    },
    {
      path: '/campaigns/:id',
      name: 'CampaignShow',
      component: CampaignShow,
    },
    {
      path: '/auto_campaigns/:id/edit',
      name: 'AutoCampaignEdit',
      component: AutoCampaignEdit,
    },
    {
      path: '/auto_campaigns/:id',
      name: 'AutoCampaignShow',
      component: AutoCampaignShow,
      beforeEnter: (to, from, next) => {
        const routesToSkip = ['budz', 'start']
        if (!routesToSkip.includes(to.params.id)) { next() }
      }
    },
    {
      path: '/reports/loyalty_points',
      name: 'LoyaltyPoints',
      component: LoyaltyPoints,
    },
    {
      path: '/reports/impact',
      name: 'ImpactReport',
      component: ImpactReport,
    },
    {
      path: '/merchants/:id/sharing',
      name: 'SharingLinks',
      component: SharingLinks,
    },
    {
      path: '/merchants/:id/program',
      name: 'Program',
      component: Program,
    },
    {
      path: '/users',
      name: 'UsersIndex',
      component: UsersIndex
    },
    {
      path: '/users/:id/edit',
      name: 'UsersEdit',
      component: UsersEdit
    },
    {
      path: '/users/new',
      name: 'UsersNew',
      component: UsersEdit
    },
    {
      path: '/passcode/:id',
      name: 'Passcode',
      component: Passcode,
      query: { 
        f: '' // f (boolean) {member_has_password}
      }
    },
    {
      path: '/stashboard/:id',
      name: 'Stashboard',
      component: Stashboard,
      props: true
    }
  ]
});

export default router
